__turbopack_context__.v({
  "passport_prompt": "ozUNya_passport_prompt",
  "passport_prompt__badge": "ozUNya_passport_prompt__badge",
  "passport_prompt__content_card": "ozUNya_passport_prompt__content_card",
  "passport_prompt__content_card_inner": "ozUNya_passport_prompt__content_card_inner",
  "passport_prompt__content_cards": "ozUNya_passport_prompt__content_cards",
  "passport_prompt__continue_without_passport_button": "ozUNya_passport_prompt__continue_without_passport_button",
  "passport_prompt__donation_heart": "ozUNya_passport_prompt__donation_heart",
  "passport_prompt__donation_text": "ozUNya_passport_prompt__donation_text",
  "passport_prompt__inner": "ozUNya_passport_prompt__inner",
  "passport_prompt__list": "ozUNya_passport_prompt__list",
});
